import { Flex } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { FlexProps } from '@chakra-ui/layout/dist/types/flex';

export interface FooterProps extends FlexProps {
  children: ReactNode;
  justify?: string;
  bg?: string;
}

export const Footer: React.FC<FooterProps> = ({
  children,
  justify = 'flex-end',
  bg = 'gray.100',
  ...props
}) => {
  return (
    <Flex
      py={4}
      w="100%"
      px="8"
      gridGap="4"
      borderTop="1px solid"
      borderColor="gray.300"
      {...props}
      bg={bg}
      justify={justify}
    >
      {children}
    </Flex>
  );
};
